import React, { Fragment } from 'react';
import Section, { Container, RestaurantSection } from '../components/Section';
import RoomPicker from '../components/RoomPicker';
import VerticalStack from '../components/VerticalStack';

import { OffersBanner } from '../components/Banner';
import Header from '../components/Header';

import roomCover from '../assets/images/deluxe/deluxe_0.jpeg';
import TextSlide from '../components/TextSlide';
import styled from 'styled-components';

import cover1 from '../assets/images/cover/frontside.jpg';
import cover2 from '../assets/images/cover/fishingboat.jpeg';
import cover3 from '../assets/images/cover/relaxing.jpeg';
import cover4 from '../assets/images/cover/adventure.jpeg';
import responsive from '../utils/responsive';
import defaultLogo from '../assets/images/logo.png';

import theme from '../theme';
import TeamSection from '../components/TeamSection';
import withHelmet from '../utils/withHelmet';
import BookingForm from '../components/booking/BookingForm';

export const Collage = styled.div`
  position: relative;
  height: 100vh;
  display: grid;
  grid-gap: 0.5em;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas: 
    "c c b"
    "d a a";
    
  ${responsive.md.andSmaller`
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-template-areas: 
      "c c"
      "a a"
      "b d";
  `};
}
`;

const MLogo = styled.img`
  width: 18em;
  height: 12em;
  object-fit: contain;

  border: 1px solid white;
  background: ${theme.colors.primary.alpha(0.6).toHex()};
  border-radius: 50%;
  padding: 1em;

  ${responsive.sm.andSmaller`
    height: 10em;
  `}
`;

export const Image = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`;

const Decorator = ({ content }) => (
  <Fragment>
    <Header
      style={{ marginTop: '11%' }}
      title={'La Villa Budva'}
      subtitle={content.frontage.subtitle}
      LogoComponent={<MLogo src={defaultLogo} />}
    />
    <OffersBanner phone={content.info.tel} email={content.info.mail} content={content} />
  </Fragment>
);

const HomePage = ({ location, content }) => (
  <VerticalStack location={location}>
    <Container id={'welcome'}>
      <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
        <Collage>
          <Image src={cover1} style={{ gridArea: 'a' }} />
          <Image src={cover2} style={{ gridArea: 'b' }} />
          <Image src={cover3} style={{ gridArea: 'c' }} />
          <Image src={cover4} style={{ gridArea: 'd' }} />
        </Collage>
        <Decorator content={content} />
      </div>
      <TextSlide {...content.frontage.welcome}>{content.frontage.welcome.body}</TextSlide>
    </Container>

    <Section id={'rooms'} background={roomCover} decorator={<Header />} BottomWidget={BookingForm}>
      <RoomPicker rooms={content.rooms} content={content} />
    </Section>
    <div id={'dining'}>
      <RestaurantSection {...content.frontage.restaurants} />
      <TeamSection {...content.team} />
    </div>
  </VerticalStack>
);

export default withHelmet('homepage')(HomePage);
